<template>
  <div class="addressedit">
    <XR-head :titleText="titleText" :rightShow="false" ref="headObj"></XR-head>
    <div v-if="!loaded">      
      <mu-row gutter>
        <mu-col width="90" tablet="50" desktop="33">
          <mu-text-field label="收货人" helpText="请输入收货人姓名" icon=":fa fa-user" labelFloat fullWidth v-model="editInfo.Receiver" />
        </mu-col>
      </mu-row>      
      <mu-row gutter>
        <mu-col width="90" tablet="50" desktop="33">
          <mu-text-field label="手机号" type="number" helpText="请输入您的手机号" icon=":fa fa-phone" labelFloat fullWidth v-model="editInfo.Phone" />
        </mu-col>
      </mu-row>    
      <mu-row gutter>
        <mu-col width="90" tablet="50" desktop="33">
          <mu-text-field label="省市区" helpText="请选择省市区" icon=":fa fa-map" labelFloat fullWidth v-model="address" @focus="openBottomSheet" />
          <mu-bottom-sheet :open="bottomSheet" @close="closeBottomSheet">            
            <mu-picker :slots="addressSlots" :visible-item-count="5" @change="addressChange" :values="address" @itemClick="closeBottomSheet"/>
          </mu-bottom-sheet>
        </mu-col>
      </mu-row>
      <!--
      <mu-row gutter>
        <mu-col width="90" tablet="50" desktop="33">
          <mu-text-field label="邮编" type="number" helpText="请输6位数邮编" icon=":fa fa-truck" labelFloat fullWidth v-model="editInfo.PosCode"  :maxLength="6" />
        </mu-col>
      </mu-row>
      -->
      <mu-row gutter>
        <mu-col width="90" tablet="50" desktop="33">
          <mu-text-field label="详细地址" multiLine :rows="2" :rowsMax="5" :maxLength="50" helpText="请输入您的详细地址" icon=":fa fa-map-marker" labelFloat fullWidth v-model="editInfo.Address" />
        </mu-col>
      </mu-row>   
      <mu-row gutter>
        <mu-col width="95" tablet="50" desktop="33" class="btn-div">          
          <mu-raised-button label="确 定" class="demo-raised-button" primary fullWidth @click="submit()" />
        </mu-col>
      </mu-row>  
    </div>
    <XR-toast @onClose="goBack" ref="XRtoast"></XR-toast>
  </div>
</template>

<script>
var address = {
  '北京': {'北京':['北京']},
  '湖北': {'武汉':['武昌区','汉阳区','青山区'], '黄石':['黄石']},
  '台湾': {'台北市':['台北市']}
}
export default {
  data () {
    return {
      titleText: this.$route.query.id?'编辑收货地址':'添加收货地址',
      loaded:true,
	  isSubmit:false,
      password:"",
      bottomSheet: false,
      selectAddress:'',      
      addressSlots: [
        {
          width: '100%',
          textAlign: 'right',
          values: ['北京']
        }, {
          width: '100%',
          textAlign: 'center',
          values: ['北京市']
        }, {
          width: '100%',
          textAlign: 'left',
          values: ['东城区']
        }
      ],
      address: ['北京', '北京市','东城区'],
      addressProvince: '北京',
      addressCity: '北京市',
      addressArea: '东城区',
      editInfo:{
        ReceiveId: 0,
        Receiver:'',
        Province : '北京',
        City:'北京市',
        Area:'东城区',
        Address:'',
        Phone:'',
        PosCode:''
      }
    }
  },
  mounted:function(){
    this.$refs.XRtoast.load()   
    this.getAreaList()
  },
  methods: {
    getAreaList(){
      var ths = this;   
      ths.$post(
        "/Shop/BaseServer/GetAreaAllListGroup"
      ).then(function(res) {
        if(!res.IsSuccess){
          ths.$refs.XRtoast.failed(res.Msg, true)
        }else{     
          address= JSON.parse(res.Data) 
          ths.addressSlots[0].values = Object.keys(address)   
          
          if(ths.$route.query.id){ 
            ths.getInfo()
          }else{
            ths.loaded = false
            ths.$refs.XRtoast.hide()
          }    
        }
      });
    },
    addressChange (value, index) {
      switch (index) {
        case 0:
          this.addressProvince = value
          var cirtyList = address[value]
          var keys = Object.keys(cirtyList)          
          this.addressSlots[1].values = keys
          this.addressCity = keys[0]
          
          var areaList = address[this.addressProvince][this.addressCity]        
          this.addressSlots[2].values = areaList
          this.addressArea = areaList[0]
          break
        case 1:      
          this.addressCity = value
          var arr1 = address[this.addressProvince][value]          
          this.addressSlots[2].values = arr1
          this.addressArea = arr1[0]
          break
        case 2:
          this.addressArea = value
          break
      }
      this.address = [this.addressProvince, this.addressCity, this.addressArea]
      this.editInfo.Province = this.addressProvince
      this.editInfo.City = this.addressCity
      this.editInfo.Area = this.addressArea
    },
    closeBottomSheet () {
      this.bottomSheet = false
    },
    openBottomSheet () {
      this.bottomSheet = true
    },
    getInfo:function(){
      var ths = this;   
      ths.$post(
        "/Shop/UserServer/GetReceiveAddress",
        JSON.stringify({ReceiveId: this.$route.query.id})
      ).then(function(res) {
        if(!res.IsSuccess){
          ths.$refs.XRtoast.failed(res.Msg, true)
        }else{       
          ths.editInfo = res.Data
          ths.address = [ ths.editInfo.Province, ths.editInfo.City, ths.editInfo.Area ]
          ths.addressProvince = ths.editInfo.Province
          ths.addressCity = ths.editInfo.City
          ths.addressArea = ths.editInfo.Area
          ths.$refs.XRtoast.hide()
          ths.loaded = false
        }
      });
    },
    submit: function(){
	  if (this.isSubmit){
	    return
	  }
	  this.isSubmit = true
    if (!this.editInfo.PosCode) {
      this.editInfo.PosCode = "000000";
    }
      var ths = this;   
      ths.$post(
        "/Shop/UserServer/EditReceiveAddress",
        JSON.stringify(this.editInfo)
      ).then(function(res) {
        if(!res.IsSuccess){
          ths.$refs.XRtoast.failed(res.Msg, true)
        }else{       
          ths.$refs.XRtoast.success(res.Msg, true)
        }
		ths.isSubmit = false
      })
	  .catch(function (err) {
	    ths.isSubmit = false
        console.log(err)
      });
    },
    goBack(){
      this.$router.goBack()
    }
  }
}
</script>
<style>
.addressedit{
  background: white;
}
.addressedit .btn-div {
  padding: 40px 0 0 16px;
}
.addressedit .demo-raised-button {
  height: 50px;
}
</style>



// WEBPACK FOOTER //
// src/pages/usercenter/addressedit.vue